var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
export function getAnswersByType(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield api.get(`/api/internal/inspections/${inspectionId}/answers_by_type`);
        return data;
    });
}
export function patchInspectionSystem(inspectionId, inspectionSystemId, completedBySubcontractor) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield api.patch(`/api/internal/inspections/${inspectionId}/inspection_systems/${inspectionSystemId}`, { inspection_system: { completed_by_subcontractor: completedBySubcontractor } });
        return data;
    });
}
